import React from "react";

interface OrderFulfilmentIconProps {
  isActive?: boolean;
}

/** Package / fulfilment box for Order Fulfilment sidebar item. */
export const OrderFulfilmentIcon: React.FC<OrderFulfilmentIconProps> = ({
  isActive = false,
}) => {
  const color = isActive ? "var(--active-color)" : "#83829D";

  return (
    <svg
      width="21"
      height="21"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21 8.5V16.2C21 17.3046 20.1046 18.2 19 18.2H5C3.89543 18.2 3 17.3046 3 16.2V8.5"
        stroke={color}
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 3L21 8.5L12 14L3 8.5L12 3Z"
        stroke={color}
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 14V21"
        stroke={color}
        strokeWidth="1.6"
        strokeLinecap="round"
      />
      <path
        d="M7.5 11.1L12 14L16.5 11.1"
        stroke={color}
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
